import i18next from 'i18next'
import React from 'react'
import { DataLayer } from '../../../utils/datalayer'
import { SVGIcon } from '../../../utils/svgicon'
import { routeUpdaters } from '../routes/routesState'
import { SearchTab } from '../search/searchState'
import { navigate } from 'widgets-for-react'

export type SearchBarProps = {
  searchString: string
  searchTab: SearchTab
  extraClasses?: string
  setSearchString: (_: string) => void
  onSubmit?: () => void
}

const SearchBarLayoutAux = (p: SearchBarProps) => (
  <section className={`search ${p.extraClasses || ''}`}>
    <form
      className="search__form container--m gutter--m"
      id="site-search"
      role="search"
      onSubmit={(e) => {
        e.preventDefault()
        if (p.onSubmit) p.onSubmit()
        const referralPage = window.location.href
        DataLayer.internalSearch(
          p.searchString,
          p.searchTab,
          i18next.language,
          referralPage
        )
        navigate(
          `${routeUpdaters(i18next.language).search.url}?term=${
            p.searchString
          }&tab=${p.searchTab}`
        )
      }}
    >
      <label htmlFor="site-search-input" className="sr-text">
        {i18next.t('search:placeholder')}
      </label>
      <input
        type="search"
        id="site-search-input"
        inputMode="search"
        className="search__input form-control"
        placeholder={i18next.t('search:placeholder')}
        value={p.searchString}
        onChange={(e) => p.setSearchString(e.currentTarget.value)}
      />
      <button
        type="submit"
        className="search__button"
        title={i18next.t('search:search')}
      >
        <span className="sr-text">{i18next.t('search:search')}</span>
        <SVGIcon className="search__icon" size={20} iconId="search" />
      </button>
    </form>
  </section>
)

export const SearchBarLayout = (p: SearchBarProps) => (
  <SearchBarLayoutAux {...p} />
)
